import moment from '../../../libs/moment';

export const formatDate = date => webix.i18n.dateFormatStr(moment(date).toDate())
